import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import EnhancedTableHead from './EnhancedTableHead';
import EnhancedTablePagination from './EnhancedTablePagination';
import { desc, stableSort, getSorting } from 'utils/table';

const styles = theme => ({
  headerButton: {
    float: 'right'
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px'
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  }
});

class EnhancedTable extends React.Component {
  state = {
    order: 'asc',
    orderBy: '',
    page: 0,
    rowsPerPage: 25
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  render = () => {
    const { data, classes, colNames } = this.props;
    const { rowsPerPage, page, order, orderBy } = this.state;

    if (data && data.length === 0) {
      return (
        <Paper>
          <div className={classes.tableWrapper}>
            { this.props.renderHeading() }
          </div>
        </Paper>
      );
    }

    return (
      <Paper>
        <div className={classes.tableWrapper}>
          { this.props.renderHeading() }
          <Divider light />
          <Table>
            <EnhancedTableHead colNames={colNames} order={order} orderBy={orderBy} onRequestSort={this.handleRequestSort} />
            <TableBody>
              { stableSort(data, getSorting(order, orderBy, colNames))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(this.props.renderRow) }
            </TableBody>
          </Table>
        </div>
        <EnhancedTablePagination
          data={data}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  };
}

EnhancedTable.propTypes = {
  data: PropTypes.array.isRequired,
  colNames: PropTypes.array.isRequired,
  renderHeading: PropTypes.func.isRequired,
  renderRow: PropTypes.func.isRequired,
}

const styled = withStyles(styles)(EnhancedTable);
export default styled;



// WEBPACK FOOTER //
// ./src/components/Table/index.js